import OlsShopContainer from '../../shop/components/OlsShopContainer';

class ShopContainer extends OlsShopContainer {
  /**
   * You can easily overwrite one or more page-level components and other properties here.
   * The pages you can overwrite are:
   * - CartList
   * - PlaceholderProductList
   * - ProductDetail
   * - ProductList
   *
   * To overwrite, simply do:
   * ProductDetail = MyOtherProductDetailPage;
   *
   */
}

export default ShopContainer;
